var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"question-tooltip-container"},[_c('a-tooltip',_vm._b({attrs:{"placement":"top"}},'a-tooltip',_vm.$attrs,false),[_c('svg-icon',{staticClass:"tooltip-icon",attrs:{"icon-class":'tooltip-icon2'}}),_c('template',{slot:"title"},[_vm._t("default")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }